export const isArguments = (x: unknown): x is IArguments => toString.call(x) === '[object Arguments]'
export const isFunction = (x: unknown): x is Function => toString.call(x) === '[object Function]'
export const isString = (x: unknown): x is string => toString.call(x) === '[object String]'
export const isNumber = (x: unknown): x is number => toString.call(x) === '[object Number]'
export const isDate = (x: unknown): x is Date => toString.call(x) === '[object Date]'
export const isRegExp = (x: unknown): x is RegExp => toString.call(x) === '[object RegExp]'
